import {Component} from '@angular/core';
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";
import {BaseState} from "@base/entities/BaseEntities";

class State extends BaseState {
    Tabs: any[] = [];
    CurrentTabIndex: number = 0;
    IsShowOnlyTabs: boolean = false;
    IsShowOnlyAccordion: boolean = false;
    IsShowStepNumbers: boolean = false;
    IsShowCustomButtonText: boolean = false;
    IsShowCustomButtonIcon: boolean = false;
}

@Component({
    selector: 'app-demo-tabs',
    templateUrl: './demo-tabs.component.html',
    styleUrls: ['./demo-tabs.component.scss', '../../styles/demo-styles.scss']
})
export class DemoTabsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoTabsComponent', State);
    }

    protected override OnInitComponent() {
        this.State.Tabs = this.GetPageTabs();
    }
    
    public OnIsShowOnlyTabsChanged() {
        if (this.State.IsShowOnlyTabs)
            this.State.IsShowOnlyAccordion = false;
    }
    
    public OnIsShowOnlyAccordionChanged() {
        if (this.State.IsShowOnlyAccordion)
            this.State.IsShowOnlyTabs = false;
    }

    public GetTabsMarkup() : string {
        let result = '<m4u-tabs [Items]="State.Tabs" [(SelectedIndex)]="State.CurrentTabIndex"';
        
        if (this.State.IsShowOnlyTabs)
            result += ' [IsShowOnlyTabs]="true"';
        
        if (this.State.IsShowOnlyAccordion)
        {
            result += ' [IsShowOnlyAccordion]="true"';
            
            if (this.State.IsShowStepNumbers)
                result += ' [IsShowStepNumber]="true"';
            
            if (this.State.IsShowCustomButtonText)
                result += ' CustomButtonText="{{\'YOUR_RESOURCE\' | RC:THIS}}"';
            
            if (this.State.IsShowCustomButtonIcon)
                result += ' CustomButtonIcon="mdi YOUR_CUSTOM_BUTTON_ICON" [OnCustomButtonClicked]="YOUR_CUSTOM_CALLBACK($event)"';
        }
        
        return result + '></m4u-tabs>'
    }
    
    private GetPageTabs(): any[] {
        return [
            {
                index: 0,
                text: 'Tab Name 1',
                Name: "Tab1"
            },
            {
                index: 1,
                text: 'Tab Name 2',
                Name: "Tab2"
            },
            {
                index: 2,
                text: 'Tab Name 3',
                Name: "Tab3"
            },
            {
                index: 3,
                text: 'Tab Name 4',
                Name: "Tab4"
            },
        ];
    }
}
